const operators = [
    { name: 'Lofty Tours', logo: 'https://daxww42wiw8kq.cloudfront.net/WTvalentininvestmentco%28msa%29ltd551520245271716814633898Lofty_Logo_1.png' },
    { name: 'Nature Surf Africa Safaris', logo: './img/naturesurf.jpeg' },
    { name: 'SXM', logo: './img/SXM_Logo.png' },
    { name: 'Rossmann Safaris', logo: './img/Rossmann-Safaris-Logo.jpg' },
    { name: 'Last Minute Africa', logo: './img/lastminuteafrica_logo.jpeg' },
];

const TrustedBy = () => (
    <section>
        <div className="wrap">
            <p className="eyebrow" style={{ textAlign: 'center' }}>Trusted Across East Africa</p>
            <h3 style={{ textAlign: 'center', fontWeight: 400, color: 'var(--muted)', fontSize: '1rem', marginTop: 8 }}>
                Trusted by Top Tour Operators in East Africa
            </h3>

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 32,
                    marginTop: 44,
                }}
            >
                {operators.map((op, i) => (
                    <div className="trust-plate" key={i}>
                        <img src={op.logo} alt={op.name} />
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default TrustedBy;